import { ErrorCodeGeneralImpl } from "../data/ErrorCodeGeneralImpl";
import { IErrorCodeGeneralRepository } from "../domain/repositories/IErrorCodeGeneralRepository";
import { ErrorCodeGeneralUseCase } from "../domain/useCases/ErrorCodeGeneralUseCase";
import { ErrorCodeGeneralViewModel } from "../presentation/viewModel/ErrorCodeGeneralViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ErrorCodeGeneralInjection extends InjectionModule {
  private static readonly errorCodeGeneralRepositoryToken = Symbol(
    "IErrorCodeGeneralRepository",
  );
  private static readonly errorCodeGeneralUseCaseToken = Symbol(
    "ErrorCodeGeneralUseCase",
  );
  private static readonly errorCodeGeneralViewModelToken = Symbol(
    "ErrorCodeGeneralViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.errorCodeGeneralRepositoryToken,
      useClass: ErrorCodeGeneralImpl,
    },
    {
      scope: "otherRepo",
      token: this.errorCodeGeneralUseCaseToken,
      useClass: ErrorCodeGeneralUseCase,
    },
    {
      scope: "viewModel",
      token: this.errorCodeGeneralViewModelToken,
      useClass: ErrorCodeGeneralViewModel,
    },
  ];

  static getRepo(): IErrorCodeGeneralRepository {
    return this.resolve(this.errorCodeGeneralRepositoryToken);
  }

  static getUseCase(): ErrorCodeGeneralUseCase {
    return this.resolve(this.errorCodeGeneralUseCaseToken);
  }
}
